import * as React from "react";
import { ITriggerManualJob } from "../../../redux/types/ITriggerManualJob";
import TextDataInput from "../../../repertoire/components/textDataInput/TextDataInput";
import {
    triggerManualJob,
} from "../../../redux/thunks/HomeThunks";
import { ComboBox } from "office-ui-fabric-react";
import { SaveAndClose } from "./SaveAndClose";

export interface IGenerateStatementDetailsParametersProps {
    createNewJob: () => any;
    triggerManualJob: typeof triggerManualJob;
    manualJobParameters: ITriggerManualJob;
    formControls: any;
    jobType?: string;
    enableMemberNumber?:boolean;
}
const GenerateStatementDetailsParameters = (props: IGenerateStatementDetailsParametersProps) => {
    const [data, setData] = React.useState(props.formControls);
    const [generalError, setGeneralError] = React.useState<string[]>([]);

    const validateFields = (): string[] => {
        const format = data.find(item => item.Caption === 'Format');
        const undoItem = data.find(item => item.Caption === 'Do/Undo Generation');
        const paymentRun = data.find(item => item.Caption === 'Payment Run');
        const memberNumberItem = data.find(item => item.Caption === 'Member Numbers');

        const memberNumbers = memberNumberItem?.CurrentValue?.trim();
        const disallowedDelimiters = [' ', ',', '.', ':'];

        let error: string | null = null;

        if (!format || format.CurrentValue === '') {
            error = 'Format is required';
        }
        else if (!undoItem || undoItem.CurrentValue === '') {
            error = 'Do/Undo Generation is required';
        }
        else if (!paymentRun || paymentRun.CurrentValue === '') {
            error = 'Payment Run is required';
        }
        else if (memberNumbers) {
            if (disallowedDelimiters.some(delim => memberNumbers.includes(delim))) {
                error = 'Member Numbers contain invalid delimiters';
            }
            else {
                const detectedDelimiter = memberNumbers.match(/[^a-zA-Z0-9]/)?.[0];
                const segments = detectedDelimiter ? memberNumbers.split(detectedDelimiter) : [memberNumbers];

                const allAlphaNumeric = segments.every(entry => /^[a-zA-Z0-9]+$/.test(entry.trim()));
                if (!allAlphaNumeric) {
                    error = 'Each Member Number must be alphanumeric only';
                }
            }
        }
        
        const errors = error ? [error] : [];
        setGeneralError(errors);
        return errors;
    };

    const setParamsAndTriggerManualJob = async (_manualJobParameters: ITriggerManualJob) => {
        const errors = validateFields();
        if (errors.length > 0) {
            return false;
        }

        await props.triggerManualJob(data);
        return true;
    };

    const handleChange = (formItem: any, value?: any) => {
        setData((prevState) => {
            return prevState.map((item) => {
                if (
                    item.Caption === 'Member Numbers' &&
                    formItem.Caption === 'Do/Undo Generation' &&
                    value === 'Undo'
                ) {
                    return { ...item, CurrentValue: '' };
                }
                
                if (item.Caption === formItem.Caption) {
                    return {
                        ...item,
                        CurrentValue: value as string,
                    };
                }

                return item;
            })
        });
    };

    const dismissAlert = () => {
        setGeneralError([]);
    };

    const getFormComponents = (jobControls) => {
        return jobControls.map((formItem) => {
            const controlWithOptions = formItem.Options && Array.isArray(formItem.Options);
            var optionList;
            if (formItem.Caption !== 'Payment Run') {
                optionList = controlWithOptions ? formItem.Options.map((option) => ({ key: option.code, text: option.description })) : [];
            } else {
                optionList = formItem.DataSourceRepo.paymentRuns.map((option) => ({ key: option.code, text: option.description }));
            }

            if (formItem.Type === 'combobox') {
                return (
                    <div className="form-group col-md-6 col-sm-6 col-xs-12" key={formItem.Caption}>
                        <ComboBox
                            selectedKey={formItem.CurrentValue || ''}
                            label={formItem.Caption}
                            options={optionList}
                            onChange={(e, selectedOption) => {
                                if (selectedOption) handleChange(formItem, selectedOption.key);
                            }}
                            useComboBoxAsMenuWidth
                            calloutProps={{ calloutMaxHeight: 270 }}
                            autoComplete="on"
                            allowFreeform={true}
                        />
                    </div>
                );
            }
            if (formItem.Type === 'text-input') {
                return (
                    <div className="form-group col-md-6 col-sm-6 col-xs-12" key={formItem.Caption}>
                        <div className="dropdownDataInput">
                        {props.enableMemberNumber && <TextDataInput
                                label={formItem.Caption}
                                fieldName={formItem.Caption}
                                changeData={(text) => handleChange(formItem, text)}
                                value={formItem.CurrentValue as string}
                                isHidden={false}
                                isMandatory={false}
                                readOnly={jobControls.find(item => item.Caption === 'Do/Undo Generation').CurrentValue === 'Do' ? false : true}
                            />}
                        </div>
                    </div>
                );
            }
        });
    };

    const { manualJobParameters, createNewJob } = props;
    return (
        <>
            
            <div className="form-group col-md-12 col-sm-12 col-xs-12">
                    <div className="alert alert-warning alert-dismissible">
                        <span>{'Please ensure that you have ran the Undo GSD job for the selected parameters if required'}</span>
                    </div>
                    {generalError && generalError.length> 0 && (
                        <div className="alert alert-danger alert-dismissible">
                            <span>{generalError}</span>
                            <button type="button" className="close" aria-label="Close" onClick={dismissAlert}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    )}
                <div className="row">{data && getFormComponents(data)}</div>
                <div className="row">
                    <SaveAndClose
                        manualJobParameters={manualJobParameters}
                        triggerManualJob={setParamsAndTriggerManualJob}
                        createNewJob={createNewJob}
                    />
                </div>
            </div>
        </>
    );
};

export default GenerateStatementDetailsParameters;